// extracted by mini-css-extract-plugin
export var boldText = "_39-4";
export var checkboxContainer = "_39-6";
export var closeIcon = "_39-i";
export var container = "_39-0";
export var drawer = "_39-8";
export var drawerContent = "_39-9";
export var extraSmallText = "_39-5";
export var fulfillmentGroupTable = "_39-e";
export var largeText = "_39-3";
export var loadingSpinnerContainer = "_39-j";
export var mediumText = "_39-2";
export var narrow = "_39-f";
export var notificationLink = "_39-l";
export var packageCheckIconContainer = "_39-7";
export var slideoutHeaderActions = "_39-g";
export var slideoutHeaderActionsShifted = "_39-h";
export var slideoutHeaderContainer = "_39-a";
export var slideoutModal = "_39-c";
export var stickyHeaderWrapper = "_39-b";
export var table = "_39-k";
export var tableContainer = "_39-d";
export var tertiaryText = "_39-1";